import React from 'react';

export const useRetryableLoad = (load: (signal: AbortSignal) => void): (() => void) => {
  const controller = React.useRef<AbortController | null>(null);

  const run = (): void => {
    controller.current?.abort();
    controller.current = new AbortController();
    load(controller.current.signal);
  };

  React.useEffect(() => {
    run();
    return () => controller.current?.abort();
  }, []);

  return run;
};
